import { Home } from "./Home";
import { Delegations } from "./Delegations";
import { Vacation } from "./Vacation";

export const icons = { Home, Delegations, Vacation };
